var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulletsHover = function SvgBulletsHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 7,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bullets--hover_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3.006,
    r: 3,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bullets--hover_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 3.006,
    r: 3,
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bullets--hover_svg__c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 3.006,
    r: 3,
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bullets--hover_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 3.006,
    r: 3,
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bullets--hover_svg__e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 3.006,
    r: 3,
    fill: "#fff",
    opacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bullets--hover_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .006h6v6H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bullets--hover_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 .006h6v6h-6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bullets--hover_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 .006h6v6h-6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bullets--hover_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 .006h6v6h-6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bullets--hover_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 .006h6v6h-6z"
  })))));
};
export { SvgBulletsHover as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDQ2IDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgo8Y2lyY2xlIGN4PSIzIiBjeT0iMy4wMDU4NiIgcj0iMyIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDEpIj4KPGNpcmNsZSBjeD0iMTMiIGN5PSIzLjAwNTg2IiByPSIzIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMikiPgo8Y2lyY2xlIGN4PSIyMyIgY3k9IjMuMDA1ODYiIHI9IjMiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAzKSI+CjxjaXJjbGUgY3g9IjMzIiBjeT0iMy4wMDU4NiIgcj0iMyIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDQpIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjMiIGN4PSI0MyIgY3k9IjMuMDA1ODYiIHI9IjMiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDAiPgo8cmVjdCB3aWR0aD0iNiIgaGVpZ2h0PSI2IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjAwNTg1OTM4KSIvPgo8L2NsaXBQYXRoPgo8Y2xpcFBhdGggaWQ9ImNsaXAxIj4KPHJlY3Qgd2lkdGg9IjYiIGhlaWdodD0iNiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwIDAuMDA1ODU5MzgpIi8+CjwvY2xpcFBhdGg+CjxjbGlwUGF0aCBpZD0iY2xpcDIiPgo8cmVjdCB3aWR0aD0iNiIgaGVpZ2h0PSI2IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAgMC4wMDU4NTkzOCkiLz4KPC9jbGlwUGF0aD4KPGNsaXBQYXRoIGlkPSJjbGlwMyI+CjxyZWN0IHdpZHRoPSI2IiBoZWlnaHQ9IjYiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMCAwLjAwNTg1OTM4KSIvPgo8L2NsaXBQYXRoPgo8Y2xpcFBhdGggaWQ9ImNsaXA0Ij4KPHJlY3Qgd2lkdGg9IjYiIGhlaWdodD0iNiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQwIDAuMDA1ODU5MzgpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";